/**
 * POC animated lobby — view switch (multi <-> single).
 * CSS-only: the container that just became visible gets a one-shot crossfade class (fx.css) and,
 * on tier full, html[data-fx-stagger] is stamped for a short window so its first cards rise in
 * (Game.module.css). No React re-render of the scroll contents, nothing touched mid-gesture.
 */

import { FX_ENABLED } from './fxFlag';
import { getMotionTier } from './motionTier';
import { playOneShotClass, stampHtmlAttribute } from './oneShot';

const STAGGER_WINDOW_MS = 900;

export const playViewSwitchEffect = (viewMode: 'multi' | 'single'): (() => void) | undefined => {
  if (!FX_ENABLED || getMotionTier() === 'off') return undefined;

  const container = document.querySelector(`[data-view="${viewMode}"][data-section-container]`);
  playOneShotClass(container, 'fx-view-in', 600);

  return getMotionTier() === 'full' ? stampHtmlAttribute('data-fx-stagger', STAGGER_WINDOW_MS) : undefined;
};
